<template>
  <el-menu
    :default-active="$route.path"
    mode="vertical"
    unique-opened
    background-color="#1C1E2F"
    text-color="#4C5275"
    active-text-color="#fff"
  >
    <sidebar-item :routes="routes"/>
  </el-menu>
</template>

<script>
import SidebarItem from './SidebarItem';

export default {
  components: { SidebarItem },
  computed: {
    routes() {
      return this.$router.options.routes;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?7624b854